// src/pages/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../api/api';
import toast from 'react-hot-toast';
import './LoginPage.css';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [errors,   setErrors]   = useState({});
  const { login } = useAuth();
  const navigate  = useNavigate();

  const validate = () => {
    const e = {};
    if (!username.trim()) e.username = 'ಬಳಕೆದಾರ ಹೆಸರು ನಮೂದಿಸಿ';
    if (!password)        e.password = 'ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ';
    if (password && password.length < 4) e.password = 'ಕನಿಷ್ಠ 4 ಅಕ್ಷರಗಳಿರಬೇಕು';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const tid = toast.loading('ಲಾಗಿನ್ ಆಗುತ್ತಿದೆ...');
    try {
      const { data } = await authAPI.login(username.trim(), password);
      toast.dismiss(tid);
      if (data.success) {
        login(data.data.user, data.data.token);
        toast.success(`ಸ್ವಾಗತ, ${data.data.user.full_name_kannada}! 🎉`, { duration: 3000 });
        navigate('/dashboard');
      }
    } catch (err) {
      toast.dismiss(tid);
      const msg = err.response?.data?.message || 'ಲಾಗಿನ್ ವಿಫಲವಾಯಿತು';
      toast.error(msg, { duration: 4000, icon: '❌' });
      setErrors({ form: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      {/* Video background */}
      <video className="login-video" autoPlay muted loop playsInline
        onError={e => { e.target.style.display='none'; }}>
        <source src="/videos/login1.mp4" type="video/mp4" />
      </video>
      <div className="login-gradient-bg" />
      <div className="login-overlay" />

      {/* Back button */}
      <button className="login-back-btn" onClick={() => navigate('/')}>
        ← ಹಿಂದೆ
      </button>

      {/* Login card */}
      <div className="login-card-wrap">
        <div className="login-card">
          {/* Header */}
          <div className="login-header">
            <div className="login-logo">🍚</div>
            <h1 className="login-title">ಅಕ್ಷರ ದಾಸೋಹ</h1>
            <p className="login-subtitle">ನಿಮ್ಮ ಖಾತೆಗೆ ಲಾಗಿನ್ ಮಾಡಿ</p>
          </div>

          {/* Form */}
          <form className="login-form" onSubmit={handleSubmit} noValidate>
            {/* Username */}
            <div className={`form-group ${errors.username ? 'has-error' : ''}`}>
              <label className="form-label">
                <span className="label-icon">👤</span>
                ಬಳಕೆದಾರ ಹೆಸರು
              </label>
              <div className="input-wrap">
                <input
                  className="form-input"
                  type="text"
                  placeholder="ನಿಮ್ಮ username ನಮೂದಿಸಿ"
                  value={username}
                  onChange={e => { setUsername(e.target.value); setErrors(p=>({...p,username:''})); }}
                  autoComplete="username"
                  autoFocus
                />
              </div>
              {errors.username && <span className="field-error">⚠ {errors.username}</span>}
            </div>

            {/* Password */}
            <div className={`form-group ${errors.password ? 'has-error' : ''}`}>
              <label className="form-label">
                <span className="label-icon">🔒</span>
                ಪಾಸ್‌ವರ್ಡ್
              </label>
              <div className="input-wrap">
                <input
                  className="form-input"
                  type={showPass ? 'text' : 'password'}
                  placeholder="ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setErrors(p=>({...p,password:''})); }}
                  autoComplete="current-password"
                />
                <button type="button" className="toggle-pass" onClick={() => setShowPass(!showPass)}>
                  {showPass ? '🙈' : '👁️'}
                </button>
              </div>
              {errors.password && <span className="field-error">⚠ {errors.password}</span>}
            </div>

            {/* Form error */}
            {errors.form && (
              <div className="form-alert-error">
                ❌ {errors.form}
              </div>
            )}

            {/* Submit */}
            <button className={`login-submit-btn ${loading ? 'loading' : ''}`} type="submit" disabled={loading}>
              {loading ? (
                <><span className="spinner" /> ಪ್ರವೇಶಿಸುತ್ತಿದೆ...</>
              ) : (
                <><span>ಪ್ರವೇಶಿಸಿ</span><span className="btn-arrow">→</span></>
              )}
            </button>
          </form>

          {/* Roles info */}
          <div className="roles-info">
            <span className="role-chip role-admin">Admin</span>
            <span className="role-chip role-principal">ಮುಖ್ಯೋಪಾಧ್ಯಾಯರು</span>
            <span className="role-chip role-clerk">ಗುಮಾಸ್ತರು</span>
          </div>

          <p className="login-help">
            ಸಮಸ್ಯೆಯಿದ್ದರೆ ಶಾಲೆಯ Admin ಅನ್ನು ಸಂಪರ್ಕಿಸಿ
          </p>
        </div>
      </div>
    </div>
  );
}
